import styled, { css } from 'styled-components';

export const Container = styled.div<{ $direction?: 'left' | 'right' }>`
  height: 64px;
  width: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: ${({ $direction }) => ($direction === 'left' ? 'flex-end' : 'flex-start')};

  @media (max-width: 1440px), (max-height: 900px) {
    width: 40px;
    height: 48px;
  }
`;

export const Button = styled.button<{ $active?: boolean; disabled?: boolean }>(
  ({ theme: { color, shadows }, disabled }) => css`
    width: 44px;
    display: flex;
    position: relative;
    padding: 0;
    margin: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
    pointer-events: ${disabled ? 'none' : 'auto'};
    justify-content: center;

    &:hover ${Svg} {
      fill: ${color.ui8};
      filter: ${shadows.sidebarButtonShadowHover};
    }
    &:hover ${IconContainer} {
      fill: ${color.s2};
      color: ${color.s2};
    }
    @media (max-width: 1440px), (max-height: 900px) {
      width: 36px;
      height: 48px;
    }
  `,
);

export const Svg = styled.svg<{
  $active?: boolean;
  $direction?: 'left' | 'right';
  disabled?: boolean;
}>(
  ({ $active, $direction, theme: { transition, color, shadows }, disabled }) => css`
    width: 44px;
    height: 64px;
    filter: ${shadows.sidebarButtonShadow};
    pointer-events: none;
    transform: scaleX(${$direction === 'left' ? '1' : '-1'});

    ${transition.default};
    fill: ${disabled ? 'transparent' : $active ? color.ui6 : 'transparent'};
    @media (max-width: 1440px), (max-height: 900px) {
      width: 36px;
      height: 48px;
    }
  `,
);

export const IconContainer = styled.div<{ $active?: boolean; disabled?: boolean }>(
  ({ theme: { color, transition }, $active, disabled }) => css`
    fill: ${disabled ? color.ui4 : $active ? color.s1 : color.ui2};
    color: ${disabled ? color.ui4 : $active ? color.s1 : color.ui2};
    ${transition.default};
    pointer-events: none;
  `,
);
